import initSmartBanner from '@sectionsJS/smart-banner';

$(async () => {
  initSmartBanner();
});
